<template>
  <div>
    <!-- <div>
      <img src="../../assets/logo.png"/>
    </div> -->
    <div id="dContentdetalis">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
          tag="span" :to="{path:'/Informations/bzhjs'}">标准化建设</router-link>
      </div>

      <div>
        <div>{{ tableData.title }}</div>
        <div id="contents" v-html="tableData.content"></div>
      </div>
      <el-divider content-position="left">附件</el-divider>
      <el-row>
        <el-col :span="6" v-for="(item, index) in tableData.itemFile" :key="index">
          <div class="pdfbtn" @click="openPdf(item)">{{item.name}}</div>
        </el-col>
      </el-row>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
    <div id="mdContentdetalis">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
          tag="span" :to="{path:'/Informations/bzhjs'}">标准化建设</router-link>
      </div>
      <div>
        <div>{{ tableData.title }}</div>
        <div id="mcontents" v-html="tableData.content"></div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
    <el-drawer title="文件预览" size="50%" :visible.sync="dialogTableVisible" :direction="direction"
      :before-close="handleClose">
      <div class="ylpdf">
        <iframe :src="url" id="iframeBox" ref="iframeRef" frameborder="0"
          style="width: 100%; height: 100%"></iframe>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import qs from 'qs'
  import pdf from 'vue-pdf'
  export default {
    components: {
      pdf,
    },
    data() {
      return {
        clientHeight: '',
        tableData: [],
        infoid: '',
        loading: false,
        title: '',
        Player: null,
        Player1: null,
        dialogTableVisible: false,
        direction: 'rtl',
        configVideo: {
          id: "",
          url: "",
          volume: 1,
          autoplay: false,
        },
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        },
        url: '',
        numPages: null,
        isShow: false
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("mdContentdetalis").style.display = "block";
        document.getElementById("dContentdetalis").style.display = "none";
      } else {
        document.getElementById("dContentdetalis").style.display = "block";
        document.getElementById("mdContentdetalis").style.display = "none";
      };
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);

    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        this.search();
      },
      fetchNumPages() {
        if (!this.url) {
          return;
        }
        this.isShow = false

        let loadingTask = pdf.createLoadingTask(this.url)
        loadingTask.promise.then(pdf => {
          console.log(pdf)
          this.numPages = pdf.numPages
        }).catch(err => {
          this.isShow = true
        })
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/bzh/getOne/' + this.$route.query.id + ''
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title
          if (cData && cData.data) {
            that.config.title = cData.data.title;
            that.config.description = cData.data.content;
            // 如果 files 是字符串，需要解析；如果是数组，直接使用
            if (typeof cData.data.files === 'string') {
              cData.data.itemFile = JSON.parse(cData.data.files)
            } else {
              cData.data.itemFile = cData.data.files || []
            }
            that.tableData = cData.data
          }
          console.log(that.tableData)
        }).catch(function(error) {
          console.log(err);
        })
      },
      openPdf(val) {
        this.dialogTableVisible = true
        this.url = val.fileUrl

      }
    }
  }
</script>

<style scoped>
  #dContentdetalis {
    width: 70%;
    margin-right: 15%;
    margin-left: 15%;
    height: 100%;
  }

  #dContentdetalis>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #dContentdetalis>#cNav>span:nth-child(1),
  #dContentdetalis>#cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #dContentdetalis>#cNav>span:nth-child(1):hover,
  #dContentdetials>#cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    font-size: 1.5em;
    font-weight: 800;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 40px;
    font-size: 18px;
  }

  /*mobile*/
  #mdContentdetalis {
    margin: auto 20px;
    height: 100%;
  }

  #mdContentdetalis>#mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mdContentdetalis>#mcNav>span:nth-child(1),
  #mdContentdetalis>#mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mdContentdetalis>#mcNav>span:nth-child(1):hover,
  #mdContentdetials>#mcNav>span:nth-child(2):hover {
    color: #mFF9900;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    font-size: 1.5em;
    font-weight: 800;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 30px;
    font-size: 16px;
  }

  .d-video {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
  }

  .nav-video {
    width: 50%;
  }

  .pdfbtn {
    cursor: pointer;
    text-align: left;
  }

  .pdfbtn:hover {
    color: rgb(149, 111, 23);
  }

  .ylpdf {
    height: 100%;
    overflow-y: scroll;
  }

  /* 垂直滚动条 */
  .ylpdf .el-drawer__container::-webkit-scrollbar {
    width: 6px;
    /* 设置滚动条宽度 */
  }

  .ylpdf .el-drawer__container::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 滚动条轨道颜色 */
  }

  .ylpdf .el-drawer__container::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条滑块颜色 */
  }

  .ylpdf .el-drawer__container::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滚动条滑块hover颜色 */
  }
</style>



// WEBPACK FOOTER //
// src/pages/informationsDetials/bzhDetials.vue